// Country-to-Telegram-link mapping for MBE Alert
// Static defaults act as fallback; runtime uses dynamic map from backend.

export const STATIC_COUNTRY_LINKS = {
  IT: 'https://t.me/+syhrtJ-b3mBhMDg1',
  GR: 'https://t.me/+alwt2I0OYig5MzE1',
  CY: 'https://t.me/+Srv3fkM_YEc4NTY9',
  PH: 'https://t.me/+58NEU36tml5kYWY1',
  SG: 'https://t.me/+Bwb2UR14Hi45NGI1',
  BN: 'https://t.me/+d6Oh3ksurocxYTI1',
};

export const DEFAULT_LINK = 'https://t.me/+58NEU36tml5kYWY1';

// Runtime dynamic map (populated by CountryContext after fetch)
let dynamicLinks = { ...STATIC_COUNTRY_LINKS };

export const setDynamicLinks = (map) => {
  if (map && typeof map === 'object') {
    dynamicLinks = { ...STATIC_COUNTRY_LINKS, ...map };
  }
};

export const getLinkForCountry = (code) => {
  if (!code) return DEFAULT_LINK;
  const upper = String(code).toUpperCase();
  return dynamicLinks[upper] || DEFAULT_LINK;
};

// Backwards compat exports
export const COUNTRY_LINKS = STATIC_COUNTRY_LINKS;
export const SUPPORTED_COUNTRIES = Object.keys(STATIC_COUNTRY_LINKS);
